<div class="toasterError" *ngIf="show">
  <div class="toasterStart">
    <img src="/assets/svg/warning.svg" class="imageWarning"/>
    <div class="texts">
    <span class="title">{{title}}</span>
    <span class="text">{{text}}</span>
    </div>
  </div>
  <img src="/assets/svg/icon_close_white.svg" (click)="closeToaster()" class="closeIcon"/>
</div>